import React, { ReactNode, useState } from 'react';
import { RateProps } from '../components/Offramp/api/rate';
import { RampData } from '../components/v4/commonApi/ramp';
import OnrampPaymentContext from './onrampPaymentContext';

const OnrampPaymentProvider = ({ children }: { children: ReactNode }) => {
  const [stateV4, setStateV4] = useState<RampData | undefined>();
  const [error, setError] = useState<boolean>(false);
  const [rate, setRate] = useState<RateProps | undefined>();
  const [merchant, setMerchant] = useState<any>(null);
  return (
    <OnrampPaymentContext.Provider
      value={{
        stateV4,
        setStateV4,
        error,
        setError,
        rate,
        setRate,
        merchant,
        setMerchant,
      }}
    >
      {children}
    </OnrampPaymentContext.Provider>
  );
};

export default OnrampPaymentProvider;
